<section id="banner" class="full-width">
    <div class="d-flex flex-row justify-content-center banner-space">
        <div class="max-width">

            <ngb-carousel
                [showNavigationArrows]="true"
                [showNavigationIndicators]="true"
                interval="20000"
                [keyboard]="true"
                [pauseOnHover]="true"
                [wrap]="true"
                [activeId]="'sliderThree'"
            >
                <ng-container *ngFor="let banner of banners">
                    <ng-template ngbSlide class="flicking-panel">
                        <div class="content-panel">
                            <div class="section-signature tablet-center">
                                <div class="section-signature-text">{{ 'Best Auto Body' | translate }}</div>
                            </div>
                            <div class="banner-title">{{banner.title | translate}}</div>
                            <div class="banner-subtitle">{{banner.text | translate}}</div>
                            <div>
                                <button class="button" (click)="moveUrl(banner.url)">{{banner.button | translate}}</button>
                            </div>
                        </div>
                        <div class="outer-mask">
                            <div class="inner-mask">
                                <div class="content"></div>
                            </div>
                        </div>
                        <div [style.background-image]="'url(' + banner.bg + ')'" class="banner-bg"></div>
                    </ng-template>
                </ng-container>
            </ngb-carousel>

        </div>
    </div>
</section>

<section id="main-services" class="section section-side-space section-content">
    <div class="section-title-container">
        <div class="section-signature center">
            <i class="icon-car-alt"></i>
        </div>
        <div class="section-title" [innerHTML]="'We’re a company of talented engineers & mechanics' | translate"></div>
        <div class="section-subtitle">
            {{ 'We are one of the leading auto repair companies.' | translate }}
        </div>
    </div>
    <div class="item-list max-width mobile-item-list-1 tablet-item-list-2">
        <ul class="ul-reset">
            <ng-container *ngFor="let item of services">
                <li class="item">
                    <div class="title-icon">
                        <i class="{{item.icon}}"></i>
                    </div>
                    <div class="title">{{item.title | translate}}</div>
                    <div class="subtitle">{{item.subtitle | translate}}</div>
                </li>
            </ng-container>
        </ul>
    </div>
    <div class="pt-5">
        <button class="button small jump-button" (click)="moveUrl('services')">{{ 'View Our Services' | translate }}</button>
    </div>
</section>

<section id="main-introduce" class="section">
    <div class="section-title-container section-side-space mb-5">
        <div class="section-signature center">
            <i class="icon-car-alt"></i>
        </div>
        <div class="section-title">
            {{ 'Best Collision & Repair Services' | translate }}
        </div>
        <div class="section-subtitle" [innerHTML]="'Best Auto Body offers high quality repairs and is an auto body repair industry leader for customer satisfaction ratings. Best Auto Body take pride in offering a clean and inviting environment.' | translate"></div>
    </div>
    <div id="main-introduce-img"></div>
    <div class="section-side-space item-list max-width tablet-item-list-1">
        <ul class="ul-reset">
            <ng-container *ngFor="let item of introduce">
                <li class="item">
                    <div class="title-icon">
                        <i class="{{item.icon}}"></i>
                    </div>
                    <div class="title uppercase">{{item.title | translate}}</div>
                    <div class="subtitle">{{item.subtitle | translate}}</div>
                </li>
            </ng-container>
        </ul>
    </div>
</section>

<section id="main-warrenty" class="section section-side-space section-color-revert bg-image">
    <div class="bg-mask bg-image-container">
        <div class="section-title-container">
            <div class="section-signature center">
                <i class="icon-car-alt"></i>
            </div>
            <div class="section-title" [innerHTML]="'We Provide All Painting & Repairs Life Time Warrenty' | translate "></div>
            <div class="section-subtitle">
                {{ "Best Auto Body places such importance on the high quality of your materials and workmanship, we're confident in our repairs. We work with all insurance companies to quickly handle your auto damage claim." | translate}}
            </div>
            <div class="warrenty-img">
                <img [src]="'../../assets/warranty.png'">
            </div>
        </div>
    </div>
</section>

<section id="main-client-says" class="section section-side-space section-color-revert">
    <div class="section-title-container mb-5">
        <div class="section-signature center">
            <i class="icon-car-alt"></i>
        </div>
        <div class="section-title">
            {{ 'What Clients Say' | translate }}
        </div>
        <div class="section-subtitle">
            {{ 'We are always happy to hear your honest opinion about our service and the experience that you get at our shop' | translate }}
        </div>
    </div>
    <div class="slider-container">
        <blockquote>
            <ngb-carousel
                [showNavigationArrows]="true"
                [showNavigationIndicators]="false"
                interval="20000"
                [keyboard]="true"
                [pauseOnHover]="true"
                [wrap]="true"
                [activeId]="'reviews'"
            >
                <ng-container *ngFor="let review of reviews">
                    <ng-template ngbSlide class="flicking-panel">
                        <div class="rate-star">
                            <i *ngFor="let star of [].constructor(review.rate)" class="fas fa-star"></i>
                        </div>
                        <div class="comment">{{review.comment}}</div>
                        <div class="comment comment-user font-main">
                            <i class="fas fa-user"></i>
                            {{review.name}}
                        </div>
                    </ng-template>
                </ng-container>
            </ngb-carousel>
        </blockquote>
    </div>
    <div class="extra-comment"><a href="https://goo.gl/maps/DdbKZa8DwozetpSk7" target="_blank">** {{ 'These are all comments from Google user reviews' | translate }}</a></div>
</section>

<section id="main-contacts" class="section section-side-space">
    <div class="map">
        <iframe [src]="sanitizeUrl('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3109.5395683023544!2d-77.13663174872124!3d38.79718837948611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b24308da4f6f%3A0xe152858ed213ee2c!2sBest%20Auto%20Body%20Shop!5e0!3m2!1sen!2sus!4v1629749023916!5m2!1sen!2sus')" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>
    <div class="form">
        <div class="section-title-container">
            <div class="section-signature mobile-center">
                <i class="icon-car-alt"></i>
            </div>
            <div class="section-title">
                {{ 'Request an Appointment' | translate }}
            </div>
            <div class="section-subtitle">
                {{ 'Please fill out the contact form and our operator will contact you to schedule an appointment.' | translate }}
            </div>
        </div>
        <div class="pt-5">
            <div *ngIf="this.isMissingField" class="alert alert-danger" role="alert">
                {{ 'Please enter all requirement field(s)' | translate }}
            </div>
            <div *ngFor="let invalid of this.invalidFields" class="alert alert-warning" role="alert">
                {{ 'Please enter input in correct format' | translate: { type: invalid } }}
            </div>
            <form id="contact-form" class="d-lg-flex flex-wrap" [formGroup]="formdata" (ngSubmit)="onClickSubmit(formdata.value)" >
                <div class="col-xl-6">
                    <div class="form-group row">
                        <label for="form-firstname" class="col-xl-4 col-form-label" required>{{getContactFormFieldLabel('firstname')}}</label>
                        <div class="col-xl-8">
                            <input id="form-firstname" class="form-control" type="text" name="firstname" placeholder="John" formControlName="firstname" required>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="form-group row">
                        <label for="form-lastname" class="col-xl-5 col-form-label" required>{{getContactFormFieldLabel('lastname')}}</label>
                        <div class="col-xl-7">
                            <input id="form-lastname" class="form-control" type="text" name="lastname" placeholder="Doe" formControlName="lastname" required>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="form-group row">
                        <label for="form-email" class="col-xl-4 col-form-label">{{getContactFormFieldLabel('email')}}</label>
                        <div class="col-xl-8">
                            <input id="form-email" type="email" class="fortextbox form-control" name="email" placeholder="johndoe@gmail.com" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" formControlName="email">
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="form-group row">
                        <label for="form-phone" class="col-xl-5 col-form-label" required>{{getContactFormFieldLabel('phone')}}</label>
                        <div class="col-xl-7">
                            <input id="form-phone" class="form-control" type="tel" name="phone" placeholder="{{ 'Format: 123-456-7890' | translate }}" formControlName="phone">
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="form-group row">
                        <label for="form-text" class="col-xl-2 col-form-label" required>{{getContactFormFieldLabel('message')}}</label>
                        <div class="col-xl-10">
                            <textarea id="form-text" class="form-control" name="content" formControlName="message" placeholder="{{ 'Please add any reason about your appointment' | translate }}" required></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="form-group row form-check">
                        <div class="col-xl-2"></div>
                        <div class="col-xl-10">
                            <input type="checkbox" id="form-agree" class="form-check-input" name="agreement" formControlName="agreement" required>
                            <label for="form-agree" class="form-check-label" required>{{getContactFormFieldLabel('agreement')}}</label>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="form-group mt-5">
                        <input type="submit" class="button small" value="{{ 'Request an Appointment' | translate }}">
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>

<div class="bg-mask notification" [ngClass]="{'d-none': !submittedMail}">
    <div class="modal-win">
        <div class="message-container">
            <h2><i class="icon fas fa-envelope-open-text"></i></h2>
            <h4>{{ 'Thank You!' | translate}}</h4>
            {{ 'Your submission has been received. We will reach out to you in the future.' | translate }}
        </div>
        <div class="footer">
            <button class="button small" (click)="submittedMail = false">OK</button>
        </div>
    </div>
</div>
